import React, { useState } from "react";
import { Popover, Spin, Table, Typography, Divider, Button } from "antd";
import { catchError } from "../../utils/errorHandler";
import moment from "moment";
import { useMediaQuery } from "react-responsive";
import { getAgentLogs } from "../../services/contactReq";
import axiosInstance from "../../services/axiosInstance";

const { Text } = Typography;

const RemarksAgentList = ({ record }) => {
    const [open, setOpen] = useState(false);
    const [remarksLogs, setRemarksLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const isMobile = useMediaQuery({ maxWidth: 767 });

    const fetchRemarks = async (uuid) => {
        setLoading(true);
        try {
            const res = await axiosInstance.get(`/client/v2/become-an-agent-log/${uuid}/`)
            if (res?.status === 200) {
                setRemarksLogs(res?.data?.data || []);
            }
        } catch (err) {
            await catchError(err);
        } finally {
            setLoading(false);
        }
    };

    const handleOpenChange = (visible) => {
        setOpen(visible);
        if (visible) {
            fetchRemarks(record?.uid);
        }
    };

    // Convert each log into a 2-column key-value array
    const renderLogTable = (log, index) => {
        const data = [
            { key: "Status", value: log.status },
            { key: "Remarks", value: log.remarks },
            { key: "Client Profile", value: log.client_profile },
            { key: "Action By ", value: log.action_taken_by },
            { key: "Date", value: moment(log.action_taken_at).local().format("DD-MM-YYYY hh:mm A") },
        ];

        const columns = [
            {
                title: "Field",
                dataIndex: "key",
                key: "key",
                width: "40%",
                render: (text) => <Text strong>{text}</Text>,
            },
            {
                title: "Value",
                dataIndex: "value",
                key: "value",
                render: (text) => <Text>{text || "-"}</Text>,
            },
        ];

        return (
            <div key={index} style={{ marginBottom: 16 }}>
                <Table
                    columns={columns}
                    dataSource={data}
                    size="small"
                    pagination={false}
                    bordered
                    showHeader={false}
                />
                {index !== remarksLogs.length - 1 && <Divider style={{ margin: '12px 0' }} />}
            </div>
        );
    };

    return (
        <Popover
            content={
                loading ? (
                    <Spin />
                ) : (
                    <div style={{ maxHeight: 200, overflowY: "auto", width: isMobile ? 240 : 360 }}>
                        {remarksLogs.length > 0
                            ? remarksLogs.map(renderLogTable)
                            : <Text type="secondary">No remarks available</Text>}
                    </div>
                )
            }
            title="Remarks Logs"
            trigger="click"
            open={open}
            onOpenChange={handleOpenChange}
            placement={isMobile ? "center" : "left"}
        >
            <Button type="link">View Logs</Button>
        </Popover>
    );
};

export default RemarksAgentList
